export default {

    props: {
        fadeTime: {
            type: Number,
            default: 3000
        },
        maxVolume: {
            type: Number,
            default: 1
        },
        canFade: {
            type: Boolean,
            default: false
        },
        defaultFadeClass: {
            type: String,
            default: 'in'
        }
    },

    watch: {
        maxVolume() {
            if (!this.player) {
                return;
            }

            const currentVolume = this.player.volume();

            if (currentVolume >= this.maxVolume) {
                this.player.volume(this.maxVolume);
            }
        }
    },

    data() {
        return {
            endTimer: null,
            fadeClass: this.defaultFadeClass
        };
    },

    methods: {
        changeFadeClass(fadeClass) {
            this.fadeClass = fadeClass;
        },

        clearFading() {
            if (this.fadingInterval) {
                clearInterval(this.fadingInterval);
            }
        },

        fadeIn() {
            if (!this.canFade || !this.player) {
                return Promise.resolve();
            }

            console.log('Fade in: ' + this.$vnode.tag + ', ' + this.player.volume(), this.fadeTime);
            return new Promise((resolve) => {
                this.clearFading();
                this.fadeClass = 'in';

                if (!this.player) {
                    resolve();

                    return;
                }

                this.player.volume(0);

                this.fadingInterval = setInterval(() => {
                    if (!this.player) {
                        this.clearFading();
                        resolve();
                        return;
                    }

                    const newVolume = this.player.volume() + (100 / this.fadeTime);

                    this.player.volume(newVolume <= this.maxVolume ? newVolume : this.maxVolume);

                    if (newVolume >= this.maxVolume) {
                        this.clearFading();
                        resolve();
                    }
                }, 100);
            });
        },

        fadeOut() {
            if (!this.canFade || !this.player) {
                return Promise.resolve();
            }

            console.log('Fade out: ' + this.$vnode.tag, this.fadeTime);
            return new Promise((resolve) => {
                this.clearFading();
                this.fadeClass = 'out';

                this.fadingInterval = setInterval(() => {
                    if(!this.player || !this.player.volume){
                        this.clearFading();
                        resolve();
                        return;
                    }

                    const currentVolume = this.player.volume();
                    let newVolume = currentVolume - (100 / this.fadeTime);

                    if (newVolume <= 0) {
                        newVolume = 0;
                    }

                    console.log('New volume out', newVolume, currentVolume);

                    this.player.volume(newVolume <= this.maxVolume ? newVolume : this.maxVolume);

                    if (newVolume <= 0) {
                        this.clearFading();
                        resolve();
                    }
                }, 100);
            });
        },

        initFadeTimer() {
            if (!this.canFade || !this.player) {
                return;
            }

            if (this.endTimer) {
                clearInterval(this.endTimer);
            }

            this.endTimer = setInterval(() => {
                if (this.src || !this.player) {
                    return;
                }

                const remaining = this.player.remainingTime();

                if (remaining * 1000 <= this.fadeTime && this.maxVolume <= 0 && this.player.volume() <= 0) {
                    this.clearFading();
                    this.fadeClass = 'out';

                    clearInterval(this.endTimer);

                    return;
                }

                if (remaining * 1000 <= this.fadeTime && this.player.volume() > this.maxVolume) {
                    const newVolume = this.player.volume() - 0.01;

                    this.player.volume(newVolume <= this.maxVolume ? newVolume : this.maxVolume);
                    this.fadeOut();
                }
            }, 100);
        },

        destroyFadeTimer() {
            if (this.endTimer) {
                clearInterval(this.endTimer);
            }

            if (this.fadingInterval) {
                clearInterval(this.fadingInterval);
            }
        }
    },

    beforeDestroy() {
        if (this.canFade) {
            this.destroyFadeTimer();
        }
    }
};
